import React, { useMemo } from 'react';
import type { WidgetSize } from '../../types/dashboard';
import { BucketPerformanceList } from './BucketPerformanceList';
import {
  SYMBOL_ATR_BUCKETS,
  buildBucketPerformance,
  getTradeSymbolAtr,
} from '../../lib/trades/dashboardBucketAnalytics';

interface PerformanceBySymbolAtrWidgetProps {
  timeRange: 'week' | 'month' | 'year';
  size: WidgetSize;
  trades?: any[];
}

export const PerformanceBySymbolAtrWidget: React.FC<PerformanceBySymbolAtrWidgetProps> = ({
  timeRange, 
  size, 
  trades = [],
}) => {
  const perfData = useMemo(
    () => buildBucketPerformance({ trades, timeRange, buckets: SYMBOL_ATR_BUCKETS, metric: getTradeSymbolAtr }),
    [timeRange, trades]
  );

  return <BucketPerformanceList result={perfData} size={size} pctFormatter={(item) => `${item.pct.toFixed(2)}%`} />;
};